var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"type":_vm.getAlertType(_vm.vigenciaC3),"dense":"","color":_vm.vigenciaC3 === '' ? 'blue-grey' : ''}},[_vm._v(" "+_vm._s(_vm.getAlertText(_vm.vigenciaC3))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }